import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card } from "reactstrap";

import { useQueimaAndRisco } from "useCases/reports/QueimaCaixa";

import { handleDataProductsLength } from "redux/taxAnalises";

import { ListProducts } from "../Tables";

export const TaxAnalysisListDefault = () => {
  const {
    params,
    paramsNote,
    tipo,
    order,
    issue_date_end: end,
    issue_date_start: start,
    taxType,
  } = useSelector(state => state.taxAnalises);

  const dispatch = useDispatch();

  const { data, isLoading, revalidate } = useQueimaAndRisco({
    ...params,
    tipo,
    issue_date_end: end,
    issue_date_start: start,
    [order?.column]: order?.value,
    taxType,
  });

  const dataProducts = data?.data?.[0]?.produtos || [];

  React.useEffect(() => {
    dispatch(handleDataProductsLength({ length: dataProducts.length }));
  }, [dataProducts.length, dispatch]);

  return (
    <Card>
      <ListProducts
        data={dataProducts}
        dataRes={data}
        isLoading={isLoading}
        revalidate={revalidate}
        paramsSearch={{
          ...paramsNote,
          tipo,
          issue_date_end: end,
          issue_date_start: start,
          [order?.column]: order?.value,
          taxType,
        }}
      />
    </Card>
  );
};
